import { useEffect, useRef, useState } from "react";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Feature from '../powerful-feature/Feature';
import { SunilArora } from '../sunil-arora/SunilArora';
import './Home.scss';
import { Helmet } from "react-helmet-async";
import Testimonial from "../testimonial/Testimonial";
import { CountryFlag } from "screens/sharedScreen/CountryFlag";
import { NavLink } from "react-router-dom";

const Home = () => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.playbackRate = 1;
        }
    }, []);


    // useEffect(() => {
    //     setShowPopup(true);
    // }, []);
    // const handleClosePopup = () => {
    //     setShowPopup(false);
    // };
    // Handle play button click
    // const handlePlay = () => {
    //     setIsPlaying(true); // Set playing state to true
    // };



    const ourTeamResponsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 1700, min: 1200 },
            items: 3
        },
        desktop: {
            breakpoint: { max: 1200, min: 992 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 992, min: 768 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 1
        }
    };

    const supplyChainResponsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 3000, min: 1200 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 1200, min: 992 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 992, min: 768 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 1
        }
    }



    return (
        <>

            <Helmet>
                <title>Freight Forwarding & Global Logistics Network Services Worldwide</title>
                <meta name="description" content="Connect with top freight forwarders through a trusted global logistics network. Access reliable shipping partners and competitive international freight rates." />
                <meta name="keywords" content="Freight Forwarding Services, Shipping Logistics Services, International Freight Forwarder, Global Logistics Companies, Freight Forwarding Companies, Logistics Services, Third-party Logistics Providers, Supply Chain Logistics Solutions, International Shipping Solutions" />
            </Helmet>

            {/* {showPopup && (
                <div className="popup-overlay" onClick={handleClosePopup}>
                    <div className="popup-wrapper" onClick={(e) => e.stopPropagation()}>
                        <button className="popup-close" onClick={handleClosePopup}>
                            ×
                        </button>

                        <div className="popup-content">
                            <NavLink to="/conference-2026" onClick={handleClosePopup}>
                                <img
                                    src="/images/banner/popup.png"
                                    alt="One World Network Global Conference 2026"
                                    className="popup-image"
                                />
                            </NavLink>
                        </div>

                        <div className="popup-buttons">
                            <NavLink to="https://www.cognitoforms.com/_1WNOneWorldNetwork/_1WNGlobalConference2026RegistrationForm"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="thm-btn faq-one__btn" onClick={handleClosePopup}>
                                Register Now
                            </NavLink>
                            <NavLink
                                to="/conference-2026"
                                className="thm-btn faq-one__btn"
                            >
                                Know More
                            </NavLink>
                        </div>
                    </div>
                </div>
            )} */}
            <div>


                {/* Banner One Start */}
                <section className='page-header banner-globe'>
                    <video ref={videoRef} autoPlay muted loop playsInline>
                        <source src="https://www.oneworldnetwork.co/video/1wn-homepage.mp4" type="video/mp4" />
                    </video>
                </section>


                <section className="about-one">
                    <div className='container-fluid p-0'>
                        <div className='row'>
                            <div className='col-lg-5 cardians-implemented'>
                                <Carousel arrows={false}
                                    responsive={supplyChainResponsive}
                                    infinite={true}
                                    showDots={false}
                                    autoPlay={true}

                                >

                                    <div className="swiper-slide position-relative">
                                        <img src="images/resources/about-1.png" alt="" />
                                    </div>
                                    <div className="swiper-slide position-relative">
                                        <img src="images/resources/about-2.png" alt="" />
                                    </div>

                                    <div className="swiper-slide position-relative">
                                        <img src="images/resources/about-5.png" alt="" />
                                    </div>
                                </Carousel>
                            </div>
                            <div className='col-lg-7'>
                                <div className='about-vich-one'>
                                    <div className='section-title text-left'>
                                        <div className="section-title__tagline-box">
                                            <span className="section-title__tagline">What is <span style={{ color: "#f39f2f" }}>1</span>wn?</span>
                                        </div>
                                        <p className="about-one__text">1WN (One World Network) is a premier global logistics network connecting top-tier freight forwarders, logistics partners, and supply chain professionals worldwide. We drive global trade by offering advanced logistics solutions, freight management services, and reliable partnerships that help members grow their business, optimize shipping processes, and access competitive freight quotes. Join 1WN for expert support and a global network of trusted partners to enhance your logistics operations.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
                {/* About One End */}

                <section className="">
                    <div className="d-flex justify-content-center">
                        <a href="https://www.logi-sys.com/?utm_source=1WNnetwork&utm_medium=Bannerad&utm_campaign=March" target="_blank" rel="noreferrer">
                            <img
                                src="/images/banner/logi-sys-banner.png"

                                alt="Logi-sys-Banner"
                                className="conference-banner-img"
                                style={{ cursor: 'pointer' }}
                            />
                        </a>
                    </div>
                </section>

                <Feature />
                <CountryFlag />

                {/* <!-- sunil-arora Start --> */}
                <SunilArora />
                {/* <!-- sunil-arora End --> */}
                <Testimonial />

            </div>
        </>
    )
}

export default Home